import {
  takeLatest, call, SagaReturnType,
} from 'redux-saga/effects';

import { select } from 'app/store/utils/saga/effects';

import * as request from 'app/lib/provider/request';

import * as cardActions from '../actions';

export const config = {
  action: cardActions.logLoadingError.type,
  method: takeLatest,
};

export function* func(action: SagaReturnType<typeof cardActions.logLoadingError>) {
  const { payload } = action;

  const uuid = yield* select((state) => state.card?.common?.uuid);
  yield call(() => request.logLoadingError(uuid, payload.message));
}
